var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.983,
    height: 121.499,
    viewBox: "0 0 91.983 121.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    transform: "translate(-0.69 -0.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5731",
    "data-name": "\\uD328\\uC2A4 5731",
    d: "M72.859,78.5a4.453,4.453,0,0,0,6.622.466,45.992,45.992,0,1,0-65.392.206,4.453,4.453,0,0,0,6.618-.508,5.368,5.368,0,0,0-.486-7.024,36.346,36.346,0,1,1,53.08-.167A5.368,5.368,0,0,0,72.859,78.5Z",
    fill: "#525868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5732",
    "data-name": "\\uD328\\uC2A4 5732",
    d: "M28.256,81.475a4.452,4.452,0,0,0,2.4,6.186,45.992,45.992,0,0,0,30.5-.066,4.452,4.452,0,0,0,2.378-6.2,5.368,5.368,0,0,0-6.553-2.571,36.348,36.348,0,0,1-22.185.048A5.368,5.368,0,0,0,28.256,81.475Z",
    transform: "translate(0.867 1.489)",
    fill: "#525868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5733",
    "data-name": "\\uD328\\uC2A4 5733",
    d: "M28.256,97.694a4.452,4.452,0,0,0,2.4,6.186,46,46,0,0,0,30.5-.067,4.452,4.452,0,0,0,2.378-6.2,5.368,5.368,0,0,0-6.553-2.571,36.347,36.347,0,0,1-22.185.048A5.368,5.368,0,0,0,28.256,97.694Z",
    transform: "translate(0.867 -0.215)",
    fill: "#525868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5734",
    "data-name": "\\uD328\\uC2A4 5734",
    d: "M52.154,116.647a6.585,6.585,0,1,1-6.585-6.586A6.585,6.585,0,0,1,52.154,116.647Z",
    transform: "translate(1.225 -0.998)",
    fill: "#525868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "free-icon-lightning-3682841",
    d: "M21.225,46.95a.734.734,0,0,1-.717-.887l3.8-17.816H13.623a.734.734,0,0,1-.6-1.158L31.993.31a.734.734,0,0,1,1.316.577L29.509,18.7H40.195a.734.734,0,0,1,.6,1.158L21.824,46.64a.733.733,0,0,1-.6.31Z",
    transform: "translate(19.775 22.704)",
    fill: "#ff4e4e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricOff);
export default __webpack_public_path__ + "static/media/electric_off.b91d53156344e6a0c35faed39fe69f47.svg";
export { ForwardRef as ReactComponent };